import { TRootState } from '../reducers';
import { IGenerateAnswerState } from '../reducers/types';

export const selectGenerateAnswerResult = (state: TRootState): IGenerateAnswerState => {
  return {
    query: state.answerGeneration.query,
    answer: state.answerGeneration.answer,
    usedArticlesInfo: state.answerGeneration.usedArticlesInfo,
    prohibited: state.answerGeneration.prohibited,
    mediaRefsMap: state.answerGeneration.mediaRefsMap,
    isLoading: state.answerGeneration.isLoading,
    error: state.answerGeneration.error,
  };
};
